import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    NavItem,
    NavLink,
    Button,
    Nav,
    Row
} from "reactstrap";
export default function Table(props) {
    const { data, url, title } = props
    return (
        <>
            <Card className="card_border w-100">
                <CardHeader className="border-0 pt-0">
                    <Row className="align-items-center mobile_sec_col">
                        <div className="col">
                            <h2 className="mb-0">{props.title}</h2>
                        </div>
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    {/* <NavLink to={url} tag={Link} className="btn btn-primary">Add Sub Category</NavLink> */}
                                    <Button onClick={props.addForm} className="btn btn-primary">Add Sub Category</Button>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <div className="table-responsive">
                    <MDBDataTable striped bordered responsive hover data={data} className="tableSize" />
                </div>
            </Card>
        </>
    )
}